import { API_KEY } from '../const/hereWeGo'

export const { H } = window
export const herePlatform = new H.service.Platform({
  apikey: API_KEY
})
